export type SmartBannerOptions = {
  enabledPlatforms?: string
  festivalName?: string
  button?: string
  closeLabel?: string
  storeApple?: string
  storeGoogle?: string
  title?: string
  iconApple?: string
  iconGoogle?: string
  buttonUrlApple?: string
  buttonUrlGoogle?: string
  disablePositioning?: string
}

export class SmartBanner {
  _options: SmartBannerOptions
  platform: 'ios' | 'android' | undefined
  element: HTMLElement | null = null
  closed = false

  constructor(_options: SmartBannerOptions = {}) {
    this._options = _options
    this.platform = this.detectPlatform()
  }

  detectPlatform(): 'ios' | 'android' | undefined {
    const ua = navigator.userAgent || navigator.vendor
    if (/android/i.test(ua)) return 'android'
    if (/iPad|iPhone|iPod/.test(ua)) return 'ios'
    return undefined
  }

  get buttonUrl(): string {
    if (this.platform === 'android') return this._options.buttonUrlGoogle ?? '#'
    if (this.platform === 'ios') return this._options.buttonUrlApple ?? '#'
    return '#'
  }

  get icon(): string {
    if (this.platform === 'android') return this._options.iconGoogle ?? ''
    if (this.platform === 'ios') return this._options.iconApple ?? ''
    return ''
  }

  get options(): SmartBannerOptions {
    return this._options
  }

  get html(): string {
    return `
      <div class="smartbanner">
        <span>${this._options.title ?? 'App'}</span>
      </div>
    `
  }

  get getStoreText(): string {
    if (this.platform === 'android') return this.options.storeGoogle ?? ''
    if (this.platform === 'ios') return this.options.storeApple ?? ''
    return ''
  }

  publish(): void {
    if (this.closed) return
    const wrapper = document.createElement('div')
    wrapper.innerHTML = this.html.trim()
    this.element = wrapper.firstElementChild as HTMLElement
    if (!this.element) return
    document.body.appendChild(this.element)
    this.bindEvents()
  }

  exit(): void {
    this.closed = true
    if (this.element) {
      this.element.remove()
    }
    document.dispatchEvent(new CustomEvent('smartbanner.exit'))
  }

  bindEvents(): void {
    const button = this.element?.querySelector('.js_smartbanner__button')
    const exit = this.element?.querySelector('.js_smartbanner__exit')

    if (button) {
      button.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('smartbanner.clickout'))
      })
    }

    if (exit) {
      exit.addEventListener('click', () => {
        this.exit()
      })
    }
  }
}

export default SmartBanner
